export const NB_CHUNK_ON_LIST = 10_000;
export const NB_PARAMS_SAVED_MAX = 600;
